import { engineSupports, isValidEngineId } from '../../../../core/engines';
import type { Connection } from '../../../../types/electron';

export type QueryPreviewButtonState = {
  readonly isVisible: boolean;
  readonly isEnabled: boolean;
};

export function getSupportsQueryPreview(connection: Connection | undefined): boolean {
  if (!connection) {
    return false;
  }

  const override = connection?.supportsQueryPreview;
  if (typeof override === 'boolean') {
    return override;
  }

  // Connection.engine is optional and defaults to 'mssql' when omitted.
  // This keeps query preview available for legacy saved connections.
  const engine = connection.engine || 'mssql';
  if (!isValidEngineId(engine)) {
    return false;
  }

  return engineSupports(engine, 'tableExplorer', 'supportsQueryPreview');
}

export function getQueryPreviewButtonState(args: {
  readonly supportsQueryPreview: boolean;
  readonly isLoading: boolean;
}): QueryPreviewButtonState {
  const isVisible = args.supportsQueryPreview;
  const isEnabled = args.supportsQueryPreview && !args.isLoading;
  return { isVisible, isEnabled };
}
